var BookapiTransferOffersResponse = /** @class */ (function () {
    function BookapiTransferOffersResponse() {
        this.isOk = false;
        this.bookapiTransferOffers = [];
    }
    BookapiTransferOffersResponse.prototype.setIsOk = function (state) {
        this.isOk = state;
    };
    BookapiTransferOffersResponse.prototype.getIsOk = function () {
        return this.isOk;
    };
    BookapiTransferOffersResponse.prototype.addBookapiTransferOffer = function (bookApiTransferOffer) {
        this.bookapiTransferOffers.push(bookApiTransferOffer);
    };
    BookapiTransferOffersResponse.prototype.getBookapiTransferOffers = function () {
        return this.bookapiTransferOffers;
    };
    return BookapiTransferOffersResponse;
}());
export { BookapiTransferOffersResponse };
